import { render, staticRenderFns } from "./ChangeProviderStatusChart.vue?vue&type=template&id=2bdb41ed&"
import script from "./ChangeProviderStatusChart.vue?vue&type=script&lang=js&"
export * from "./ChangeProviderStatusChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports